import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

/*
This component is for handling when you don't know if an image that comes from the CMS will be a SVG or not.
If you know that your image is/is-not svg, need to use StaticImage, or just the regular img tag,
this component should not be needed for those uses.
*/

/*
Many CMS images have no alt text set in the media library, which leaves them with
an empty alt (the milestone timeline on the history page is ~100 such images). When
that happens, fall back to a readable label derived from the file name: drop the
leading order prefix like "06-", drop the extension, and turn separators into
spaces. A real alt set in the media library always wins over this fallback.
*/
const altFromUrl = (url) => {
  if (!url) return "";
  let name = url.split("?")[0].split("/").pop() || "";
  name = name.replace(/\.[a-z0-9]+$/i, "");
  name = name.replace(/^\d+[a-z]?[-_ ]+/i, "");
  name = name.replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1);
};

const CmsImage = ({ image, ...other }) => {
  // An empty image field in the CMS (or a deleted media item) arrives as null.
  // Render nothing rather than failing the whole static build over one image.
  if (!image) {
    if (typeof window === "undefined") {
      console.warn("CmsImage: skipped an empty CMS image field");
    }
    return null;
  }

  const alt =
    image.altText ||
    altFromUrl(image.localFile ? image.localFile.publicURL : image.sourceUrl);

  // We need to use the regular img tag for svg & gif files.
  if (
    !image.localFile ||
    image.localFile.extension === "svg" ||
    image.localFile.extension === "gif"
  ) {
    return (
      <img
        src={!image.localFile ? image.sourceUrl : image.localFile.publicURL}
        alt={alt}
        {...other}
      />
    );
  }

  // Use GatsbyImage for all other images that come from our CMS.
  const img = getImage(image.localFile);
  return <GatsbyImage alt={alt} image={img} {...other} />;
};

export default CmsImage;
